import React, {} from 'react';
import { joinClassNames } from './joinClassNames.js';
const styles = {"text":"Text-module__text__UK72-","toneDefault":"Text-module__toneDefault__QIiU9","toneMuted":"Text-module__toneMuted__eul91","sizeBody":"Text-module__sizeBody__vNM-E","sizeSmall":"Text-module__sizeSmall__0WIgd"};
const TONE_CLASS_NAMES = {
    default: styles.toneDefault,
    muted: styles.toneMuted
};
const SIZE_CLASS_NAMES = {
    body: styles.sizeBody,
    small: styles.sizeSmall
};
/** A paragraph in the body font. */
export function Text({ tone = 'default', size = 'body', children }) {
    return React.createElement("p", { className: joinClassNames(styles.text, TONE_CLASS_NAMES[tone], SIZE_CLASS_NAMES[size]) }, children);
}
//# sourceMappingURL=Text.js.map